module.exports = __webpack_public_path__ + "img/ES1491.f98a52e5.svg";